import { useState } from "react";
// @mui
import { MenuItem, Stack } from "@mui/material";
// locales
import { useLocales } from "../../../locales";
// components
import Image from "../../../components/image";
import MenuPopover from "../../../components/menu-popover";
import { IconButtonAnimate } from "../../../components/animate";
import { useAuthContext } from "../../../auth/useAuthContext";
import CountryFlag from "../../../components/iconify/CountryFlag";

// ----------------------------------------------------------------------

export default function LanguagePopover() {
    const { allLangs, currentLang, onChangeLang } = useLocales();
    const { user, setLanguage } = useAuthContext();
    const [openPopover, setOpenPopover] = useState(null);

    const handleOpenPopover = (event) => setOpenPopover(event.currentTarget);
    const handleClosePopover = () => setOpenPopover(null);

    const handleChangeLang = async (newLang) => {
        onChangeLang(newLang);

        if (user) {
            try {
                await setLanguage(newLang);
            } catch (error) {
                console.error("Failed to save language to profile", error);
            }
        }

        handleClosePopover();
    };

    return (
        <>
            <IconButtonAnimate
                onClick={handleOpenPopover}
                sx={{
                    width: 40,
                    height: 40,
                    ...(openPopover && { bgcolor: "action.selected" }),
                }}
            >
                <CountryFlag code={currentLang.icon} style={{marginRight: 0}}/>
            </IconButtonAnimate>

            <MenuPopover
                open={openPopover}
                onClose={handleClosePopover}
                sx={{ width: 180 }}
            >
                <Stack spacing={0.75}>
                    {allLangs.map((option) => (
                        <MenuItem
                            key={option.value}
                            selected={option.value === currentLang.value}
                            onClick={() => handleChangeLang(option.value)}
                        >
                            <CountryFlag code={option.icon} />
                            {option.label}
                        </MenuItem>
                    ))}
                </Stack>
            </MenuPopover>
        </>
    );
}
